module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.17em"
    }
  }, [_vm._v("YOU CAN’T")]), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" Tell by Looking")]), _vm._v(" began as a personal quest to explore aspects, both light and dark, of a religion that is ancient and peace-loving. Islam is one of the largest religions in the world, second only to Christianity, and yet, because of a small group who have distorted and politicized this faith—and they are a small group, compared to the millions of other Muslims in the world—Islam is vilified by many. I set out to paint a different picture. One that not only shows followers of Islam are as “normal,” decent, and law-abiding as the rest of the world’s citizens, but that among those followers, like all religions, there are LBGT people who are as devout as their fellow Muslims. If one person, gay teen, straight teen, parent, Christian, Jew, or other, reads my book and has a change of mind and heart, then my quest is fulfilled.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e7f9af3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0005.vue
// module id = 69
// module chunks = 0